import { useModal } from '../../../shared/modal/useModal.vm';
import {useNavigate} from "react-router-dom";

import { IUserForm } from '../../../../interfaces/admin/user/userForm';
import { ModalType } from '../../../../constants/modalType';
import { ValidationMessages } from '../../../../constants/validationMessages';
import { useUsersApi } from '../../../../apiHooks';
import {AdminLink} from "../../../../utils";

export const useAddUser = () => {
  const navigate = useNavigate();
  const usersApi = useUsersApi();
  const {handleModal, isModalOpened, closeModal} = useModal();

  const actionHandler = async (userForm: IUserForm) => {
    const isLogin = await usersApi.addUser(userForm);

    if (isLogin) {
      handleModal(ModalType.ADD_MODAL);
      return null;
    } else {
      return ValidationMessages.INVALID_USER_EXIST;
    }
  }
  const handleNo = () => {
    navigate(AdminLink.PUBLISHING_USERS)
  }

  return {isModalOpened, actionHandler, closeModal, handleNo}
}